module.exports = __webpack_public_path__ + "img/qfpay.9c8ae8a1.svg";